import { Component, Input } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'product-badge',
    templateUrl: './product-badge.component.html',
    styleUrls: ['./product-badge.component.scss'],
    standalone: false
})
export class ProductBadgeComponent {
  @Input() name: 'ecf' | 'pstx' | 'ieo' = 'ecf';
  @Input() size: 'sm' | 'md' | 'lg' = 'md'; // For pstx only atm
  @Input() shorten = false;

  badges = {
    ecf: {
      redirect: '/equity',
    },
    pstx: {
      redirect: '/pstx',
    },
    ieo: {
      redirect: environment.ieoBaseUrl,
    },
  };

  getProductName() {
    if (this.shorten) {
      return `common.${this.name}`;
    }
    return `menu.${this.name}Title`;
  }

  getHeight() {
    if (this.size === 'lg') {
      return '32';
    }
    if (this.size === 'md') {
      return '24';
    }
    return '18';
  }
}
